<template>
  <section v-if="image_url">
    <div class="top-banner">
      <a :href="banner_link" target="_blank">
        <img :src="image_url" class="desktop-only">
        <img v-if="mobile_url" :src="mobile_url" class="mobile-only"></img>
      </a>
    </div>
  </section>
</template>
<script>
export default {
  name: "Banner",
  components: {
  },
  data() {
    return {
      index: 0,
      banners: [],
      image_url: '',
      mobile_url: '',
      banner_link: '#',
      duration: 5000
    };
  },
  mounted() {
    this.banners = this.$store.state.layout.banner
    if (this.banners.length === 0) {
      return
    }
    this.index = 0
    this.image_url = this.banners[this.index].signImageUrl
    this.mobile_url = this.banners[this.index].signMobileImageUrl
    this.banner_link = this.banners[this.index].link
    if (this.banners.length > 1) {
      // setInterval(this.rolling, this.duration)
    }
  },
  methods: {
    rolling: function () {
      this.index = this.index >= this.banners.length - 1 ? 0 : this.index + 1
      this.image_url = this.banners[this.index].signImageUrl
      if (this.banners[this.index].signMobileImageUrl !== undefined) {
        this.mobile_url = this.banners[this.index].signMobileImageUrl
      }
      this.banner_link = this.banners[this.index].link
    }
  }
};
</script>